import cx from 'classnames'
import Button from 'react-bootstrap/Button'
import Icon from '../../Icon/Icon'

import './ButtonCinestar.scss'

// TODO: Add a spinner and loading state?

const ButtonCinestar = ({
    children,
    variant,
    size = 'lg',
    type = 'button',
    iconLeft,
    iconRight,
    onClick,
    className,
    ...props
}) => {
    const classNameBtn = cx(
        `button__${variant} rounded-0`,
        {
            'text-white border-0': variant === 'primary-v1',
            'bg-white text-magentaSecondary border-0': variant === 'primary-v2',
            'text-white': variant === 'secondary',
            'd-flex align-items-center justify-content-center': iconLeft || iconRight,
        },
        className
    )

    return (
        <Button variant="default" type={type} size={size} className={classNameBtn} onClick={onClick} {...props}>
            {iconLeft && <Icon name={iconLeft} className={'me-2'} />}
            {children}
            {iconRight && <Icon name={iconRight} className={'ms-2'} />}
        </Button>
    )
}

export default ButtonCinestar
